import {
  SAVE_DISPLAYED_RETURN_REASONS,
  SAVE_SELECTED_RETURN_REASON,
  SAVE_NESTED_DISPLAYED_RETURN_REASONS,
  SAVE_SELECTED_NESTED_RETURN_REASON,
} from '../../actions/returnReasonsMonitoring';

export const initialState = {
  displayedReturnReasons: [],
  selectedReturnReason: {},
  nestedDisplayedReturnReasons: [],
  selectedNestedReturnReason: {},
};
export default (
  state = initialState,
  {
    type,
    data: {
      displayedReturnReasons = [],
      selectedReturnReason = {},
      nestedDisplayedReturnReasons = [],
      selectedNestedReturnReason = {},
    } = {},
  } = {},
) => {
  switch (type) {
    case SAVE_DISPLAYED_RETURN_REASONS:
      return {
        ...state,
        displayedReturnReasons,
      };
    case SAVE_SELECTED_RETURN_REASON:
      return {
        ...state,
        selectedReturnReason,
      };
    case SAVE_NESTED_DISPLAYED_RETURN_REASONS:
      return {
        ...state,
        nestedDisplayedReturnReasons,
      };
    case SAVE_SELECTED_NESTED_RETURN_REASON:
      return {
        ...state,
        selectedNestedReturnReason,
      };
    default:
      return state;
  }
};
